export function initializePendo(user: string, env: string) {
  if (!user || !env) return
  pendo.initialize({
    apiKey: 'f2c37023-4021-46c2-5839-52a25cc88b4e',
    visitor: {
      id: user,
    },
    account: {
      id: env,
    },
  })
}
